module.exports = __webpack_public_path__ + "img/licenca.61fc2c61.svg";